import { render } from "./Menor.vue?vue&type=template&id=36f3a76e&ts=true"
import script from "./Menor.vue?vue&type=script&lang=ts"
export * from "./Menor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__